import { useEffect, useState } from "react";
import "./preloader.scss";
import preload from "./logo.svg";

function Preloader({ loading }) {

    return (
        <div className="preloader">
            <svg viewBox="0 0 561 560" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M449.244 28.6222L332.267 202.222C324.178 214.044 339.733 228.356 350.933 218.4L466.044 118.222C469.156 115.733 473.511 117.6 473.511 121.956V434.933C473.511 439.289 467.911 441.156 465.422 438.044L116.978 21.1556C105.778 7.46667 89.6 0 71.5555 0H59.1111C26.7556 0 0 26.7556 0 59.7333V500.267C0 533.244 26.7556 560 59.7333 560C80.2667 560 99.5555 549.422 110.756 531.378L227.733 357.778C235.822 345.956 220.267 331.644 209.067 341.6L93.9556 441.156C90.8444 443.644 86.4889 441.778 86.4889 437.422V125.067C86.4889 120.711 92.0889 118.844 94.5778 121.956L443.022 538.844C454.222 552.533 471.022 560 488.444 560H500.889C533.867 560 560.622 533.244 560.622 500.267V59.7333C560.622 26.7556 533.867 0 500.889 0C479.733 0 460.444 10.5778 449.244 28.6222Z" fill="#9BC995"/>
            </svg>
        </div>
    );
}

export default Preloader;